const FlechaCircleIcon = ({ color }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="15"
        r="15"
        fill={color ? color : "url(#paint0_linear_158_110)"}
      />
      <path
        d="M12 21L18 14.5L12 8"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_158_110"
          x1="24.1696"
          y1="4.49044"
          x2="0.525434"
          y2="9.54063"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED6F00" />
          <stop offset="1" stopColor="#ED6F00" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FlechaCircleIcon;
